module.exports = __webpack_public_path__ + "img/23.61a6d92.png";